window.OrnateMiniCardDirectAddLoaded = window.OrnateMiniCardDirectAddLoaded || false;

  if (!window.OrnateMiniCardDirectAddLoaded) {
    window.OrnateMiniCardDirectAddLoaded = true;

    document.addEventListener('click', async function(event) {
      const button = event.target.closest('.js-mini-card-direct-add');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const originalText = button.dataset.addToCartText || button.textContent.trim();

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1
          })
        });

        if (!response.ok) {
          throw new Error('Add to cart failed');
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));

        const cartItems = document.querySelector('.cart__items[data-section]');

        if (cartItems) {
          const sectionId = cartItems.dataset.section;
          const requestUrl = `${window.location.pathname}?section_id=${sectionId}`;

          fetch(requestUrl)
            .then(function(res) {
              return res.text();
            })
            .then(function(html) {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const newCartItems = doc.querySelector('.cart__items[data-section]');
              const currentCartItems = document.querySelector('.cart__items[data-section]');

              if (newCartItems && currentCartItems) {
                currentCartItems.innerHTML = newCartItems.innerHTML;
                currentCartItems.dataset.empty = newCartItems.dataset.empty;
              }
            })
            .catch(function(error) {
              console.error('Cart items refresh failed:', error);
            });
        }

        button.textContent = 'Added';

        setTimeout(function() {
          button.textContent = originalText;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }, 1200);
      } catch (error) {
        console.error(error);

        button.textContent = originalText;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }, true);
  }